/**
 * /ninety/processes — My Day · Processes tab.
 *
 * VISUAL REFERENCE build for the development team: processes come from the
 * fake in-memory store in ~/components/myday/store.ts (no Supabase). Create,
 * edit (including steps), reorder and delete work in-session and reset on
 * reload.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ProcessesView } from '~/components/myday/processes/ProcessesView';

export const Route = createFileRoute('/_app/ninety/processes')({
  component: ProcessesTab,
});

function ProcessesTab() {
  return (
    <div className="px-4 sm:px-6 py-4">
      <ProcessesView />
    </div>
  );
}
